import React from 'react'

import { Table } from 'Components/Table'
import { Th } from 'Components/Table/Th'
import { Tr } from 'Components/Table/Tr'

import LocationRow from './LocationRow'

const LocationsTable = ({
  locations,
  changeSort,
  handleModalArchiveShow,
  handleModalEditShow,
  cityId,
  orderByColumn,
  isH2H,
}) => {
  return (
    <Table>
      <thead>
        <Tr>
          <Th
            className="sortable"
            onClick={() => changeSort('name', orderByColumn)}
          >
            Name
          </Th>
          <Th
            className="sortable"
            onClick={() => changeSort('label', orderByColumn)}
          >
            Label
          </Th>
          <Th
            className="sortable"
            onClick={() => changeSort('type', orderByColumn)}
          >
            Type
          </Th>
          <Th
            className="sortable"
            onClick={() => changeSort('momentsMorning', orderByColumn)}
          >
            Morning
          </Th>
          <Th
            className="sortable"
            onClick={() => changeSort('momentsLunch', orderByColumn)}
          >
            Lunch
          </Th>
          <Th
            className="sortable"
            onClick={() => changeSort('momentsAfternoon', orderByColumn)}
          >
            Afternoon
          </Th>
          <Th
            className="sortable"
            onClick={() => changeSort('isSheltered', orderByColumn)}
          >
            Sheltered?
          </Th>
          <Th
            className="sortable"
            onClick={() => changeSort('isEvent', orderByColumn)}
          >
            Event?
          </Th>
          <Th
            className="sortable"
            onClick={() => changeSort('requirePermit', orderByColumn)}
          >
            Needs Permit
          </Th>
          <Th className="align-right sortable">Actions</Th>
        </Tr>
      </thead>
      <tbody>
        {locations.map(location => (
          <LocationRow
            cityId={cityId}
            location={location}
            handleModalArchiveShow={handleModalArchiveShow}
            handleModalEditShow={handleModalEditShow}
            isH2H={isH2H}
          />
        ))}
      </tbody>
    </Table>
  )
}

export default LocationsTable
